/**
 * Created by JasonChou on 16/6/6.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/logger'
import auth from './modules/auth'
import test from './modules/test'
Vue.use(Vuex)
Vue.config.debug = true;

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth, test
  },
  //strict: debug,
  //middlewares: debug ? [createLogger()] : []
})



/** WEBPACK FOOTER **
 ** ./src/store/index.js
 **/